import { useLocation } from "react-router";
import { urlHome, urlRegisterPlayerSuccess } from "../../../urls";
import { CheckCircle } from "lucide-react";
import { BACK_DURATION } from "../../../constants";

function RegisterPlayerSuccess() {
  const { state } = useLocation();
  return (
    <div className="bg-white border p-4 rounded-lg shadow-md mt-6 w-full flex flex-col gap-4">
      <div className="border-b border-gray-200 pb-2 w-full text-xl font-bold text-center pb-4 flex items-center justify-center gap-4">
        Felicidades! Ya eres parte de nuestro club
        <CheckCircle className="size-6 text-green" />
      </div>
      <div className="flex flex-col gap-3 text-2xl!">
        <div className="flex items-center justify-between">
          <p className="text-gray-500">Nombre</p>
          <p className="text-gray-800 font-medium">{state.name}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-gray-500">Apellido</p>
          <p className="text-gray-800 font-medium">{state.lastName}</p>
        </div>
        <div className="flex items-center justify-between">
          <p className="text-gray-500">Teléfono</p>
          <p className="text-gray-800 font-medium">{state.phone}</p>
        </div>
      </div>
    </div>
  );
}

export const route = {
  path: urlRegisterPlayerSuccess(),
  element: <RegisterPlayerSuccess />,
  handle: {
    backLink: urlHome(),
    duration: BACK_DURATION,
  },
};
